const baseRoute = '/service-settings'
const createRoute = (subRoute: string) => ({
  route: `${baseRoute}/:serviceAreaId${subRoute}`,
  path: `/:serviceAreaId${subRoute}`,
})

export const ServiceSettingsAreaRoutes = {
  route: baseRoute,
  path: '/',
  ServiceSettingsServiceArea: {
    ...createRoute('/service-area'),
    Edit: createRoute('/service-area/edit'),
  },
  ServiceSettingsConfiguration: createRoute('/configuration'),
  ServiceSettingsServiceClasses: createRoute('/service-classes'),
}
